import React from 'react';
import { ReactComponent as AreaChartIconSVG } from '../img/AreaChartOutlinedIcon.svg';
/**
 * 
 * Original icon missing from MUI Material package.
 * Fixed in v7.0.1 - https://github.com/mui/material-ui/commit/d7eb57d81c673f499b8557539de8cffc1d4298f4
 */
const AreaChartOutlinedIcon = ({ ...props }) => (
  <AreaChartIconSVG
    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
    focusable="false"
    aria-hidden="true"
    {...props}
  />
);

export default AreaChartOutlinedIcon;
